module.exports = __webpack_public_path__ + "static/AboutUs-Partnership-Graphics_v1-9158bde4b959172c19b0021beb29e353.svg";